export { CELL_TYPE, TextCellType } from "./textType.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/cellTypes/textType/index.mjs
// module id = 430
// module chunks = 1